import { render, staticRenderFns } from "./AliasView.vue?vue&type=template&id=2297d31c&scoped=true"
import script from "./AliasView.vue?vue&type=script&lang=js"
export * from "./AliasView.vue?vue&type=script&lang=js"
import style0 from "./AliasView.vue?vue&type=style&index=0&id=2297d31c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297d31c",
  null
  
)

export default component.exports